import KJUR from 'jsrsasign';

export function parseJwt(token: string): KJUR.KJUR.jws.JWS.JWSResult {
  return KJUR.KJUR.jws.JWS.parse(token);
}
